module.exports = __webpack_public_path__ + "media/images/default/shared/header/main-b5b5f7a49fb8a385a5c03a3bda5f126a.jpg";